// Keuzelijsten voor het aanbod van bedrijven

export const IK_BIED_AAN = [
  "Verkoop aan B2B",
  "Verkoop aan particulieren",
  "Met uitbraak en montage",
  "Met binnenafwerking",
  "Kleine verbouwingen (bv. aanpassing opening)",
];

export const AANBOD_VOOR = [
  "Ramen en/of deuren",
  "Garagepoorten",
  "Rolluiken",
  "Screens",
  "Dakramen",
  "Veranda's",
  "Overkappingen",
  "Andere",
];

export const MATERIALEN = ["PVC", "Aluminium", "Hout"];
export const MERKEN_PVC = ["Schüco", "Kömmerling", "Veka", "Deceuninck", "Salamander"];
export const MERKEN_ALU = ["Sapa", "Schüco", "Decalu Deceuninck", "Aluprof", "Aliplast"];
export const MERKEN_HOUT = ["Meranti", "Green"];

export function slug(s) {
  return (s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
